// src/config/messaging.ts

// Messaging API is a separate microservice on port 8001
const MESSAGING_API_BASE_URL = process.env.REACT_APP_MESSAGING_API_URL || 'http://localhost:8001/api/v1';

// WebSocket URL (same host as messaging API, but ws:// protocol)
const getWebSocketUrl = (): string => {
  const baseUrl = MESSAGING_API_BASE_URL;
  // Convert http(s) to ws(s)
  const wsUrl = baseUrl.replace(/^http/, 'ws');
  // WebSocket endpoint path - no trailing slash for FastAPI WebSocket
  return `${wsUrl}/ws`;
};

export const MESSAGING_CONFIG = {
  API_BASE_URL: MESSAGING_API_BASE_URL,
  WS_URL: getWebSocketUrl(),

  // Endpoints - all with trailing slashes for FastAPI compatibility
  ENDPOINTS: {
    // Conversations
    CONVERSATIONS: '/conversations',

    // Messages (conversation)
    MESSAGES: (conversationId: number) => `/conversations/${conversationId}/messages/`,
    MESSAGE: (conversationId: number, messageId: number) => `/conversations/${conversationId}/messages/${messageId}/`,
    MESSAGES_UPLOAD: (conversationId: number) => `/conversations/${conversationId}/messages/upload/`,
    MESSAGES_READ: (conversationId: number) => `/conversations/${conversationId}/messages/read/`,
    MESSAGE_REACTIONS: (conversationId: number, messageId: number) => `/conversations/${conversationId}/messages/${messageId}/reactions/`,

    // Groups
    GROUPS: '/groups',
    GROUP: (groupId: number) => `/groups/${groupId}/`,
    GROUP_MEMBERS: (groupId: number) => `/groups/${groupId}/members/`,
    GROUP_MEMBER: (groupId: number, userId: number) => `/groups/${groupId}/members/${userId}/`,
    GROUP_MEMBER_ROLE: (groupId: number, userId: number) => `/groups/${groupId}/members/${userId}/role/`,
    GROUP_LEAVE: (groupId: number) => `/groups/${groupId}/leave/`,

    // Group Messages
    GROUP_MESSAGES: (groupId: number) => `/groups/${groupId}/messages/`,
    GROUP_MESSAGE: (groupId: number, messageId: number) => `/groups/${groupId}/messages/${messageId}/`,
    GROUP_MESSAGES_UPLOAD: (groupId: number) => `/groups/${groupId}/messages/upload/`,
    GROUP_MESSAGES_READ: (groupId: number) => `/groups/${groupId}/messages/read/`,
    GROUP_MESSAGE_REACTIONS: (groupId: number, messageId: number) => `/groups/${groupId}/messages/${messageId}/reactions/`,

    // Contacts
    CONTACTS: '/contacts/',
    CONTACT_REQUEST: '/contacts/request/',
    CONTACT_REQUESTS_PENDING: '/contacts/pending/',
    CONTACT_REQUESTS_SENT: '/contacts/pending/sent/',
    CONTACT_REQUEST_ACCEPT: (requestId: number) => `/contacts/${requestId}/accept/`,
    CONTACT_REQUEST_REJECT: (requestId: number) => `/contacts/${requestId}/reject/`,

    // Blocks
    BLOCKS: '/blocks/',
    BLOCK: (blockId: number) => `/blocks/${blockId}/`,

    // Users (search) - uses contacts/users endpoint which includes contact_status
    USERS_SEARCH: '/contacts/users/',
    USER: (userId: number) => `/users/${userId}/`,
  },

  // Pagination
  DEFAULT_MESSAGE_LIMIT: 50,

  // WebSocket reconnection
  WS_RECONNECT_INITIAL_DELAY: 1000, // 1 second
  WS_RECONNECT_MAX_DELAY: 30000, // 30 seconds
  WS_RECONNECT_MULTIPLIER: 2,
  WS_PING_INTERVAL: 30000, // 30 seconds
};

export default MESSAGING_CONFIG;
